import { render, staticRenderFns } from "./pillars-of-knowledge.vue?vue&type=template&id=68a78558&scoped=true"
import script from "./pillars-of-knowledge.vue?vue&type=script&lang=js"
export * from "./pillars-of-knowledge.vue?vue&type=script&lang=js"
import style0 from "./pillars-of-knowledge.vue?vue&type=style&index=0&id=68a78558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a78558",
  null
  
)

export default component.exports